// src/components/timer/StopTimerModal.tsx
// Modal: Encerrar sessão ou continuar contando?

import React from 'react';
import { Square, Play } from 'lucide-react';
import { useStudyTimer } from '../../contexts/StudyTimerContext';
import './StopTimerModal.css';

const fmt = (s: number) => {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
};

const StopTimerModal: React.FC = () => {
    const { activeTimer, showStopModal, closeStopModal, stopTimer } = useStudyTimer();

    if (!showStopModal || !activeTimer) return null;

    return (
        <div className="stm-overlay" onClick={closeStopModal}>
            <div className="stm-modal" onClick={e => e.stopPropagation()}>
                <div className="stm-header">
                    <span className="stm-icon">⏱️</span>
                    <h3>Encerrar sessão?</h3>
                </div>

                <p className="stm-time-display">{fmt(activeTimer.elapsed)}</p>
                <p className="stm-desc">
                    Este tempo será registrado no seu histórico de estudo.
                </p>

                <div className="stm-actions">
                    <button className="stm-btn stm-btn-continue" onClick={closeStopModal}>
                        <Play size={16} fill="currentColor" />
                        Continuar estudando
                    </button>
                    <button className="stm-btn stm-btn-stop" onClick={stopTimer}>
                        <Square size={16} fill="currentColor" />
                        Finalizar sessão
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StopTimerModal;